<h1>{{'achievement-onboarding.header' | translate}}</h1>
<p>{{'achievement-onboarding.description' | translate}}</p>
<button class="btn" (click)="onStartClick($event)">{{'achievement-onboarding.start' | translate}}</button>
